// vime player will always lock ratio except when in fullscreen mode.
// so we need to hack into it's shadow DOM tree and fix style manually.
export function enableStretchedPlayer(nativePlayer) {
  const player = nativePlayer.nativeElement;
  if (!player) throw new Error('cannot enable embedded fullscreen, player is not available yet!');
  const sr = player.shadowRoot;
  if (!sr) throw new Error('cannot enable embedded fullscreen, Shadow Dom is not loaded yet!');
  const playerEl = sr.children[0];
  playerEl.style.paddingBottom = "0";
  playerEl.style.height = "100%";
}